export function isValidEmail(email: string): boolean {
  const atIndex = email.indexOf('@');
  if (atIndex < 1) return false;
  const domain = email.slice(atIndex + 1);
  return domain.includes('.') && domain.length > 2 && !email.includes(' ');
}
